function ScrollTo() {

    $('.quick-links a[href^="#"]').on('click', function(event) {
        var target = $(this.getAttribute('href'));
        if( target.length ) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top-80
            }, 1000);
        }
    });

    $('.scrollTo').on('click', function(event) {
        var target = $(this.getAttribute('href'));
        if( target.length ) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top-80
            }, 1000);
        }
    });

}

export default ScrollTo;
